// Registra que alguien tocó un canal de contacto (WhatsApp o correo) y desde
// dónde. Solo eso: un clic no es una conversación recibida ni una venta, y
// jamás viaja el número, el mensaje ni nada de la cuenta (catálogo cerrado
// CTAS_CONTACTO en lib/contacto.js).
//
// Sin sesión va a la telemetría anónima de la portada (eventos_anonimos,
// evento 'contacto_cta'); con sesión, a eventos_v2 ('contacto_clic'), que es
// donde vive todo lo que hace una cuenta. Las dos son best-effort: medir nunca
// impide que el enlace se abra.
import { trackLanding } from './landingTracking';
import { trackEvent } from './eventTracking';
import { MODULOS } from './modulos';
import { CTAS_CONTACTO } from './contacto';

export function registrarClicContacto(canal, ubicacion, { conSesion = false } = {}) {
  const cta = `${canal}_${ubicacion}`;
  if (!CTAS_CONTACTO.includes(cta)) return;
  try {
    if (conSesion) trackEvent('contacto_clic', { modulo: MODULOS.HOME, payload: { canal, ubicacion } });
    else trackLanding('contacto_cta', { cta });
  } catch { /* la telemetría jamás bloquea el contacto */ }
}
